let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2NUYW")).then(() => parcelRequire('iv6hb'));